import React from 'react'

import logoDefault from '@/public/images/logo_default.png'

export interface SidebarHeaderProps {
  logoUrl?: string
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  logoUrl = logoDefault,
}) => {
  return (
    <div>
      <img
        className="object-contain object-left h-10 w-full"
        src={logoUrl}
        alt="Ascend Vista"
      />
    </div>
  )
}

SidebarHeader.displayName = 'SidebarHeader'

export default React.memo(SidebarHeader, (prevProps, nextProps) => {
  return prevProps.logoUrl === nextProps.logoUrl
})
